import {TEMPLATE} from '../../service/template/types';
import {ISwapSelectedSlidesAction, IAddSlidesAction} from './types/edit.types';

export const SWAP_SELECTED_SLIDES = 'SWAP_SELECTED_SLIDES_ACTION';
export const ADD_SLIDES = 'ADD_SLIDES';

export const swapSelectedSlidesAction = (newIndex: number, oldIndex: number): ISwapSelectedSlidesAction => ({
    type: SWAP_SELECTED_SLIDES,
    indices: {newIndex, oldIndex},
});

export const addSlidesAction = (slidesToAdd: number, hidden: boolean, template: TEMPLATE, toEnd?: boolean): IAddSlidesAction => ({
    type: ADD_SLIDES,
    slidesToAdd,
    hidden,
    template,
    toEnd,
});
